<a #nameRef *ngIf="linkType === LINK_TYPE.LINK && !isLinkDisabled"  [routerLink]="[redirectLink]" (contextmenu)="gaTrackLinkClickEvent()"
   (click)="gaTrackLinkClickEvent()" target="_blank" role="button" class="actions-bar__title"
   [mmTestTarget]="'link-name'" [mmTooltip]="toolTip"
   [mmTooltipDisabled]="!(nameRef.offsetWidth | isTruncatedByCss: nameRef.scrollWidth)">
   {{label}}
</a>

<a *ngIf="linkType === LINK_TYPE.IMAGE && !isLinkDisabled" [routerLink]="[redirectLink]" (contextmenu)="gaTrackLinkClickEvent()"
   (click)="gaTrackLinkClickEvent()" role="button" target="_blank">
   <img [src]="imageSource" [alt]="label" [mmTestTarget]="'link-image'" class="actions-bar__img">
</a>

<div #nameRef *ngIf="linkType === LINK_TYPE.LINK && isLinkDisabled" class="actions-bar__title actions-bar__no-link"
   [mmTestTarget]="'link-name'" [mmTooltip]="toolTip"
   [mmTooltipDisabled]="!(nameRef.offsetWidth | isTruncatedByCss: nameRef.scrollWidth)">
   {{label}}
</div>

<div *ngIf="linkType === LINK_TYPE.IMAGE && isLinkDisabled">
   <img [src]="imageSource" [alt]="label" [mmTestTarget]="'link-image'" class="actions-bar__img actions-bar__no-link">
</div>

<div *ngIf="linkType === LINK_TYPE.LINK_SERVICE">
   <span class="actions-bar__vas-title"> {{serviceInstallationLink}}</span>
   <span class="actions-bar__vas-title"> {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.VAS_LABEL_FOR' | translate }} </span>
   <a #nameRef class="actions-bar__title" [routerLink]="[redirectLink]" (contextmenu)="gaTrackLinkClickEvent()"
      (click)="gaTrackLinkClickEvent()" target="_blank" role="button" [mmTestTarget]="'link-name-service'"
      [mmTooltip]="toolTip" [mmTooltipDisabled]="!(nameRef.offsetWidth | isTruncatedByCss: nameRef.scrollWidth)">
      {{label}}
   </a>
</div>